import React from "react";
import * as Comlink from "comlink";
import Worker_FindPoints from "worker-loader!./Worker_findPoints";
export class PointFinderContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.worker = new Worker_FindPoints();
        this.grafosWorker = Comlink.wrap(this.worker);
        this.state = { point2show: undefined };
    }
    async componentDidUpdate(prevProps) {
        const { point2show } = this.state;
        const { mousePositionScaled, scaledRadius, visibleValues, y2Values } = this.props;
        const { grafosWorker } = this;
        if (prevProps.datasetMatrix !== this.props.datasetMatrix &&
            Object.keys(this.props.datasetMatrix) &&
            this.props.visibleValues === prevProps.visibleValues) {
            grafosWorker.loadQuadtree(this.props.datasetMatrix);
        }
        if (mousePositionScaled &&
            prevProps.mousePositionScaled !== mousePositionScaled) {
            const point = await grafosWorker.findSelectablePoint(mousePositionScaled, scaledRadius, visibleValues, y2Values);
            if (point) {
                this.setState({
                    point2show: {
                        x: point[0],
                        y: point[1],
                        id: point[2],
                        hasDoubleAxis: point[3],
                    },
                });
            }
            else {
                if (point2show) {
                    this.setState({ point2show: undefined });
                }
            }
        }
    }
    componentDidMount() {
        const { datasetMatrix } = this.props;
        const { grafosWorker } = this;
        grafosWorker.loadQuadtree(datasetMatrix);
    }
    componentWillUnmount() {
        this.worker.terminate();
    }
    render() {
        return this.props.mousePositionScaled
            ? this.props.render(this.state.point2show)
            : null;
    }
}
//# sourceMappingURL=PointFinderContainer.js.map